module.exports = __webpack_public_path__ + "static/media/opportunity-section-image-1.8e98992f.png";